/**Starts browser download for given blob*/
export const downloadBlob = (name: string, file: Blob) => {
  const url = window.URL.createObjectURL(file);

  // Common file types that browsers can preview
  const previewableTypes = {
    'application/pdf': true,
    'image/jpeg': true,
    'image/png': true,
    'image/gif': true,
    'image/webp': true,
    'text/plain': true,
    'text/html': true,
    'audio/mpeg': true,
    'audio/wav': true,
    'video/mp4': true,
    'video/webm': true,
  };

  if (previewableTypes[file.type as keyof typeof previewableTypes]) {
    // Open in a new tab for preview
    window.open(url, '_blank');
  } else {
    // Fallback to download for non-previewable files
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  // Clean up the URL object after a short delay to ensure the browser has time to open it
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 100);
};
